export class GameEngine {
    constructor() {
        this.score = 0;
        this.level = 1;
        this.achievements = [];
        this.consecutiveCorrect = 0;
        
        this.achievementDefinitions = [
            { id: 'first_note', name: 'First Note', icon: '🎵', requirement: 1 },
            { id: 'pitch_perfect', name: 'Pitch Perfect', icon: '🎯', requirement: 10 },
            { id: 'note_master', name: 'Note Master', icon: '⭐', requirement: 50 },
            { id: 'perfect_streak', name: 'Perfect Streak', icon: '🔥', requirement: 5 },
            { id: 'interval_expert', name: 'Interval Expert', icon: '🎼', requirement: 20 },
            { id: 'scale_wizard', name: 'Scale Wizard', icon: '🧙', requirement: 15 },
            { id: 'song_singer', name: 'Song Singer', icon: '🎤', requirement: 3 }
        ];
        
        this.loadProgress();
    }

    addPoints(points) {
        this.score += points;
        
        if (points === 100) {
            this.consecutiveCorrect++;
            this.checkForAchievements();
        } else {
            this.consecutiveCorrect = 0;
        }
        
        this.checkLevelUp();
        this.saveProgress();
    }

    checkLevelUp() {
        const newLevel = Math.floor(this.score / 1000) + 1;
        
        if (newLevel > this.level) {
            this.level = newLevel;
            this.showLevelUpNotification();
        }
    }

    showLevelUpNotification() {
        // You could implement a notification system here
        console.log(`Level up! You're now level ${this.level}!`);
    }

    checkForAchievements() {
        this.achievementDefinitions.forEach(achievementDef => {
            if (!this.achievements.find(a => a.id === achievementDef.id)) {
                if (this.meetsRequirement(achievementDef)) {
                    this.unlockAchievement(achievementDef);
                }
            }
        });
    }

    meetsRequirement(achievementDef) {
        switch(achievementDef.id) {
            case 'first_note':
                return this.score >= 100;
            case 'pitch_perfect':
                return this.score >= 1000;
            case 'note_master':
                return this.score >= 5000;
            case 'perfect_streak':
                return this.consecutiveCorrect >= 5;
            case 'interval_expert':
                return this.score >= 2000;
            case 'scale_wizard':
                return this.score >= 1500;
            case 'song_singer':
                return this.score >= 500;
            default:
                return false;
        }
    }

    unlockAchievement(achievementDef) {
        const achievement = {
            id: achievementDef.id,
            name: achievementDef.name,
            icon: achievementDef.icon,
            unlockedAt: Date.now()
        };
        
        this.achievements.push(achievement);
        this.showAchievementNotification(achievement);
        this.saveProgress();
    }

    showAchievementNotification(achievement) {
        // Add badge to UI
        const badgesContainer = document.getElementById('achievement-badges');
        const badge = document.createElement('div');
        badge.className = 'badge';
        badge.textContent = `${achievement.icon} ${achievement.name}`;
        badgesContainer.appendChild(badge);
        
        console.log(`Achievement unlocked: ${achievement.name}!`);
    }

    getScore() {
        return this.score;
    }

    getLevel() {
        return this.level;
    }

    getAchievements() {
        return this.achievements;
    }

    saveProgress() {
        const progress = {
            score: this.score,
            level: this.level,
            achievements: this.achievements,
            consecutiveCorrect: this.consecutiveCorrect,
            savedAt: Date.now()
        };
        
        localStorage.setItem('singingTutorProgress', JSON.stringify(progress));
    }

    loadProgress() {
        const saved = localStorage.getItem('singingTutorProgress');
        
        if (saved) {
            try {
                const progress = JSON.parse(saved);
                this.score = progress.score || 0;
                this.level = progress.level || 1;
                this.achievements = progress.achievements || [];
                this.consecutiveCorrect = progress.consecutiveCorrect || 0;
            } catch (error) {
                console.error('Error loading progress:', error);
            }
        }
    }

    resetProgress() {
        this.score = 0;
        this.level = 1;
        this.achievements = [];
        this.consecutiveCorrect = 0;
        localStorage.removeItem('singingTutorProgress');
    }

    getStats() {
        return {
            score: this.score,
            level: this.level,
            achievementCount: this.achievements.length,
            totalAchievements: this.achievementDefinitions.length,
            consecutiveCorrect: this.consecutiveCorrect
        };
    }
}
